import { Link } from 'react-router-dom';
import type { Movie } from '@/mocks/movies';

interface MovieCardProps {
  movie: Movie;
}

export default function MovieCard({ movie }: MovieCardProps) {
  return (
    <Link
      to={`/movie/${movie.id}`}
      className="group block cursor-pointer"
      data-product-shop
    >
      <div className="relative overflow-hidden rounded-lg aspect-[2/3] bg-cinema-card">
        <img
          src={movie.image}
          alt={movie.title}
          title={`${movie.title} - 8090影视电影大全高清在线观看`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-cinema-black via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
        <div className="absolute top-2 left-2 flex flex-wrap gap-1.5">
          {movie.isNew && (
            <span className="px-2 py-0.5 text-xs font-medium bg-cinema-crimson text-white rounded">NEW</span>
          )}
          {movie.isClassic && (
            <span className="px-2 py-0.5 text-xs font-medium bg-cinema-gold text-cinema-black rounded">经典</span>
          )}
        </div>
        <div className="absolute top-2 right-2 flex items-center gap-1 px-2 py-0.5 bg-cinema-black/70 rounded text-cinema-gold text-xs font-semibold">
          <i className="ri-star-fill text-[10px]"></i>
          {movie.rating}
        </div>
      </div>
      <div className="mt-3">
        <h3 className="text-white text-sm font-medium truncate group-hover:text-cinema-gold transition-colors">
          {movie.title}
        </h3>
        <div className="flex items-center gap-2 mt-1">
          <span className="text-cinema-text-dim text-xs">{movie.year}</span>
          <span className="text-cinema-border text-xs">|</span>
          <span className="text-cinema-text-dim text-xs">{movie.region}</span>
        </div>
        <div className="flex flex-wrap gap-1 mt-2">
          {movie.tags.slice(0, 2).map((tag) => (
            <span key={tag} className="px-1.5 py-0.5 text-[10px] text-cinema-text-dim bg-cinema-card rounded">
              {tag}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}